<main [class.sin-footer]="hideBarras()">
    <router-outlet />
</main>

<footer [hidden]="hideBarras()">
    <app-footer-bar></app-footer-bar>
</footer>
